// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chinese-font-family[data-v-1bac47dd],.english-font-family[data-v-1bac47dd]{font-family:Arial Rounded MT Bold!important}", ""]);
// Exports
module.exports = exports;
